import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {makeStyles, withStyles} from "@material-ui/core/styles";
// import {REACT_APP_API_URL} from
// imported components
import CTable from "../presentational_components/table";
import Table2 from "../presentational_components/table_2";
import BatchTable from "../presentational_components/batch_table";
import LoadingIndicator from "../presentational_components/loading_indicator";
import {trackPromise} from "react-promise-tracker";
import AlertModal from "../presentational_components/modal";
import SelectionRadioGroup from "../presentational_components/selection_component";
import Introduction from "../presentational_components/intro";
// default table data
import {input} from "../faux_data/augment_new";
//Material UI component imports
import {Stepper, Step, StepLabel, StepContent} from "@material-ui/core/";
import {Paper, Typography} from "@material-ui/core/";
import Icon from "@material-ui/core/Icon";
import InputIcon from "@material-ui/icons/Input";
import SubjectIcon from "@material-ui/icons/Subject";
import FilterBAndWIcon from "@material-ui/icons/FilterBAndW";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
//classes for step styles
import {
  InputSubmitButton,
  InputStepContainer,
  Button,
  NextButton,
  BackButton,
  StepText,
  TableWrapper,
  StartButton,
  InstructionTxt,
  ContentBlock
} from "../styles/stepper_styles.js";

import {IntroPar, Box} from "../styles/intro_styles";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    paddingTop: 20
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  stepper: {
    marginTop: "0px",
    [theme.breakpoints.up("lg")]: {
      margin: "0px auto",
      width: "80%",
      height: "100%",
      position: "relative"
    },
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  }
}));
const styles = (theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  button: {
    margin: "10px"
  },
  startButton: {
    margin: "10px",
    marginLeft: "30px"
  },
  submitButton: {
    verticalAlign: "bottom",
    margin: "15px"
  },
  stepper: {
    marginTop: "0",
    [theme.breakpoints.down("lg")]: {
      margin: "0px auto",
      width: "80%",
      height: "100%",
      position: "relative"
    },
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  stepContents: {
    padding: "100px",
    position: "relative",
    fontFamily: "Rubik-Medium"
  },
  mappings: {
    marginRight: "50px",
    padding: "10px 30px",
    background: "#F8F8F8"
  },
  headers: {
    paddingLeft: "10px 30px"
  },
  header: {
    margin: "7px 0px",
    fontFamily: "Rubik"
  },
  actionsContainer: {
    marginBottom: theme.spacing(1),
    width: "700px",
    textAlign: "right",
    margin: "0px auto",
    paddingRight: "10px"
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  paper: {
    margin: "2px 2px",
    padding: "3px 2px",
    background: "#F8F8F8"
  },
  label: {
    fontSize: "2em",
    fontFamily: "Rubik",
    fontWeight: 600
  },
  title: {
    fontSize: "1.4em",
    padding: "10px 30px",
    color: "#FFFFFF",
    fontFamily: "Rubik-Medium"
  },
  description: {
    fontFamily: "Rubik-Medium",
    fontSize: "1.2em",
    padding: "10px 54px",
    width: "90%"
  },
  field: {
    padding: "8px 0px"
  },
  padding: {
    width: 24,
    height: 46
  },
  gridList: {
    margin: "4px 0px"
  },
  heading: {
    fontFamily: "Rubik-Medium",
    fontWeight: "bold",
    padding: "20px",
    fontSize: "16px"
  }
});

class VerticalStepper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: -1,
      steps: [],
      backActive: false,
      nextActive: false,
      inputActive: true,
      modalOpen: false,
      inputSelection: null,
      coloredData: []
    };
    this.getStepContent = this.getStepContent.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.setModalState = this.setModalState.bind(this);
    this.setInputState = this.setInputState.bind(this);
  }

  componentDidMount() {
    this.initializeSteps();
    this.initializeData();
  }

  //sets the stepper headers.
  initializeSteps() {
    let taskSpec = {
      steps: [
        {
          id: 0,
          isActive: () => {
            return this.state.activeStep >= 0;
          },
          title: "Input Selection",
          icony: <InputIcon />,
          instructions: ""
        },
        {
          id: 1,
          isActive: () => {
            return this.state.activeStep >= 1;
          },
          title: "Examine Augmented Sentences",
          icony: <SubjectIcon />,
          instructions: ""
        },
        {
          id: 2,
          isActive: () => {
            return this.state.activeStep >= 2;
          },
          title: "Apply Filter and Weights",
          icony: <FilterBAndWIcon />,
          instructions: ""
        },
        {
          id: 3,
          isActive: () => {
            return this.state.activeStep >= 3;
          },
          title: "View Final Results",
          icony: <DynamicFeedIcon />,
          instructions: ""
        }
      ]
    };
    this.setState({steps: taskSpec.steps});
  }

  initializeData() {
    let data = this.beautifyData(input, "label")
    this.setState({coloredData: data})
  }


  beautifyData(data, token){
    //token is the key you are looking for.
    let labelcolor = {};
    let color = [ "#D2FA72", "#FACCBA",  "#FA9480", "#C085FD", "#E1B6E3", "#8ED7FA", "#FAA665", "#61F685"];
    let count = 0;
    data.map((d) => {
      if (!labelcolor[d[token]]) {
        d["color"] = color[count];
        labelcolor[d[token]] = color[count]
        count += 1;
      } else {
        d["color"] = labelcolor[d[token]];
      }
      d.augment.map((aug)=>{
        if(!labelcolor[aug[token]]) {
          aug["color"] = color[count];
          labelcolor[aug[token]] = color[count]
          count += 1;
        } else {
          aug["color"] = labelcolor[aug[token]];
        }
        let weightlen = aug["weight"].toString().split(".")[1].length
        if(weightlen > 2){
        let trunkweight = aug["weight"].toFixed(2)
        aug["weight"] = trunkweight
        }
      })
    });
    return data;
  }

  setInputState(sel) {
    // retrieve the selection ID from the value input in selection_component
    var input_id;
    this.state.coloredData.forEach((dict) => {
      if (dict.original === sel) {
        input_id = dict.id;
        this.setState({inputSelection: input_id});
      }
    });
  }

  //based on activeStep, gets the contents of the step.
  getStepContent(step) {
    const classes = useStyles;
    switch (step) {
      case 0:
        return (
          <ContentBlock>
            <InstructionTxt>
              Select a sentence and its label to submit for Rotom&apos;s data
              augmentation process.
            </InstructionTxt>
            <InputStepContainer>
              <SelectionRadioGroup
                data={this.state.coloredData}
                setInput={this.setInputState}
                activeStep={this.state.activeStep}
              />
            </InputStepContainer>
          </ContentBlock>
        );
      case 1:
        return (
          <ContentBlock>
            <InstructionTxt>
              Examine augmented sentences below where we applied deletion,
              replacement and InvDA operators to generate as many augmented
              sentences as possible.
              <br /> <br />
            </InstructionTxt>
            <TableWrapper>
              <CTable
                data={this.state.coloredData}
                inputId={this.state.inputSelection}
                activeStep={this.state.activeStep}
              />
            </TableWrapper>
          </ContentBlock>
        );
      case 2:
        return (
          <div>
            <InstructionTxt>
              Examine the results of filtering and weighting models that Rotom
              uses as part of its meta-learning framework to decide which
              augmented examples to discard or keep and assign weights to train
              target model. <br />
              <br /> Filtering is a simple linear classification model while
              weighting is based on a more heavy-duty Transformer model.
              <br />
              <br />
            </InstructionTxt>
            <TableWrapper>
              <Table2
                data={this.state.coloredData}
                inputId={this.state.inputSelection}
                activeStep={this.state.activeStep}
              />
            </TableWrapper>
          </div>
        );
      case 3:
        return (
          <div>
            <InstructionTxt>
              Examine below the final results after augmentation, filtering, and
              weighting. Data is now ready to be used in training the target
              model.
              <br />
              <br />
            </InstructionTxt>
            <TableWrapper>
              <BatchTable
                data={this.state.coloredData}
                inputId={this.state.inputSelection}
                activeStep={this.state.activeStep}
              />
            </TableWrapper>
          </div>
        );

      default:
        return "Unknown step";
    }
  }

  //alert modal
  setModalState() {
    let modalState = this.state.modalOpen;
    modalState = !modalState;
    this.setState({
      modalOpen: modalState
    });
  }

  //next button action
  handleNext() {
    if(this.state.activeStep === 0 && this.state.inputSelection === null ){
      this.setState({modalOpen: true})
      return
    }

    let addStep = this.state.activeStep + 1;
    let activeStep = addStep;

    let backActivated = activeStep >= 1 ? true : false;
    this.setState({
      activeStep: activeStep,
      backActive: backActivated,
      nextActive: true
    });
    this.getStepContent(activeStep);
  }
  //back button action
  handleBack() {
    let current = this.state.activeStep;
    let nextactive;
    if (this.state.activeStep === 0) {
      current = -1;
    } else {
      current = this.state.activeStep - 1;
      nextactive = current < 3 ? true : false;
    }
    this.setState({
      activeStep: current,
      nextActive: nextactive
    });
  }

  handleReset(){
    let activeStep = 0
    this.setState({
      activeStep: 0,
      tableData: []
    })
    this.getStepContent(0)
  }



  render() {
    const classes = useStyles;
    return (
      <div className={classes.stepper}>
        <LoadingIndicator />
        <AlertModal
          setModalState={this.setModalState}
          isOpen={this.state.modalOpen}
        />
        <Paper square elevation={2} className={classes.paper}>
          <Introduction
            activeStep={this.state.activeStep}
            handleNext={this.handleNext}
          />
          <Stepper
            activeStep={this.state.activeStep}
            orientation="vertical"
            className={classes.stepper}
          >
            {this.state.steps.map((step) => (
              <Step key={step.id} active={step.isActive()}>
                <StepLabel StepIconComponent={() => <Icon>{step.icony}</Icon>}>
                  <Typography
                    variant="body1"
                    variantMapping={{body1: "span"}}
                    className={classes.label}
                    color="textPrimary"
                  >
                    <StepText>{step.title}</StepText>
                  </Typography>
                </StepLabel>
                <StepContent>
                  {this.getStepContent(step.id)}
                  {this.state.activeStep === 0 && (
                    <div className={classes.actionsContainer}>
                      <InputSubmitButton
                        variant="contained"
                        background="linear-gradient(.87turn, #187039, #a3d251)"
                        onClick={this.handleNext}
                        inputActive={this.state.inputActive}
                      >
                        Submit
                      </InputSubmitButton>
                    </div>
                  )}

                  {this.state.activeStep === step.id &&
                    this.state.activeStep === 1 && (
                      <div className={classes.actionsContainer}>
                        <NextButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleNext}
                          className={classes.button}
                          nextActive={this.state.nextActive}
                        >
                          Next
                        </NextButton>
                        <BackButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleBack}
                          className={classes.button}
                          backActive={this.state.backActive}
                        >
                          Back
                        </BackButton>
                      </div>
                    )}

                  {this.state.activeStep === step.id &&
                    this.state.activeStep === 2 && (
                      <div className={classes.actionsContainer}>
                        <NextButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleNext}
                          className={classes.button}
                          nextActive={this.state.nextActive}
                        >
                          Next
                        </NextButton>
                        <BackButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleBack}
                          className={classes.button}
                          backActive={this.state.backActive}
                        >
                          Back
                        </BackButton>
                      </div>
                    )}

                  {this.state.activeStep === step.id &&
                    this.state.activeStep === this.state.steps.length - 1 && (
                      <Paper
                        square
                        elevation={0}
                        className={classes.resetContainer}
                      >
                        <div className={classes.actionsContainer}>
                          <Button
                            variant="contained"
                            background="linear-gradient(.87turn, #187039, #a3d251)"
                            onClick={this.handleReset}
                            className={classes.button}
                          >
                            Reset
                          </Button>
                          <BackButton
                            variant="contained"
                            background="linear-gradient(.87turn, #187039, #a3d251)"
                            onClick={this.handleBack}
                            className={classes.button}
                            backActive={this.state.backActive}
                          >
                            Back
                          </BackButton>
                        </div>
                      </Paper>
                    )}
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Paper>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(VerticalStepper));
